import { Badge, Button, Code, Container, DataList, Flex, Heading, IconButton, Link, RadioGroup, Spinner, Text, TextArea } from "@radix-ui/themes";
import { useNavigate, useParams } from "react-router";
import useFetch from "../../core/hooks/useFetch";
import { useEffect, useState } from "react";
import { IContract } from "../../core/types/services-types/contract-types";
import ContractService from "../../core/services/ContractService";
import { Document, Page } from "react-pdf";
import Pagination from "../../components/common/renders/pagination-render";
import BaseModal from "../../components/controls/modals/BaseModal";
import AdminService from '../../core/services/AdminService'
import { toast, ToastContainer } from "react-toastify";
import { useAppSelector } from "../../core/store";
export default function UploadedDocument() {
    const user = useAppSelector(store => store.user)
    const navigate = useNavigate()
    const [contract, setContract] = useState<IContract>()
    const [status, setStatus] = useState<string>('В обработке')
    const [message, setMessage] = useState<string>('')
    const {id} = useParams()
    const [fetchContract, isLoading, error, errors] = useFetch(async () => {
        if(id) {
        const data = await ContractService.Get(id)
        setContract(data)
        setStatus(data.status || '')
        setMessage(data.message_admin || '')
        }
    })

    const [fetchSetStatusContract, isLoadingFetchSetStatusContract, errorFetchSetStatusContract, errorsFetchSetStatusContract] = useFetch(async () => {
        if(contract) {
        const data = await AdminService.SetStatusContractUser(contract.id, status, message)
        toast.success("Успешно!")
            setTimeout(() => {
                navigate(-1)
            }, 2000)
        }
    })

    const [fetchDeleteContract, isLoadingFetchDeleteContract, errorFetchDeleteContract, errorsFetchDeleteContract] = useFetch(async () => {
        if(contract) {
            const data = await ContractService.Delete(contract.id)
            toast.success("Успешно удалено!")
            setTimeout(() => {
                navigate(-1)
            }, 2000)
        }
    })
    
    
    const [numPages, setNumPages] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
          
    function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
        setNumPages(numPages);
    }

    const renderContentPdfModal = (url: string) => {
        return (
       <Container> 
      <Document file={url} onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber} />
      </Document>
       <Pagination total={numPages} count={1} activeIndex={pageNumber} onChangeIndex={setPageNumber} classNameContainer="flex-wrap"/>
      </Container>
        )
    }

    useEffect(() => {
        fetchContract()
    }, [])
        

    useEffect(() => {
        if(error.length) toast.error(error)
    }, [error])

    return (
        <Container className="uploaded-document p-5 pt-10 bg-zinc-100">
                   <ToastContainer
              
              />

                {isLoading ? <Spinner size={'3'} /> :
                    contract ? 

            <Container className="mb-10 shadow-lg p-5 rounded-lg bg-zinc-50">
                <Container className="uploaded-document-heading mb-5"> 
                <Heading>
                    Договор №{contract?.id}
                </Heading>
                <hr />
                </Container>
                <Container className="uploaded-document-data mb-5">

                    <DataList.Root>
	<DataList.Item align="center">
		<DataList.Label minWidth="88px">Статус</DataList.Label>
		<DataList.Value>
			<Badge color={contract?.status === 'В обработке' ? "orange" : contract?.status === 'Пройдено' ? 'jade' : 'red'} variant="soft" radius="full">
				{contract?.status}
			</Badge>
		</DataList.Value>
	</DataList.Item>
	<DataList.Item>
		<DataList.Label minWidth="88px">ID</DataList.Label>
		<DataList.Value>
			<Flex align="center" gap="2">
				<Code variant="ghost">{contract?.id}</Code>
				<IconButton
					size="1"
					aria-label="Copy value"
					color="gray"
					variant="ghost"
				>
					 
				</IconButton>
			</Flex>
		</DataList.Value>
	</DataList.Item>
	<DataList.Item>
		<DataList.Label minWidth="88px">Логин пользователя</DataList.Label>
		<DataList.Value>{contract?.user.login || '-'}</DataList.Value>
	</DataList.Item>
	<DataList.Item>
		<DataList.Label minWidth="88px">Название</DataList.Label>
		<DataList.Value>
			<Link>{contract?.title || '-'}</Link>
		</DataList.Value>
	</DataList.Item>
	<DataList.Item>
		<DataList.Label minWidth="88px">Тема</DataList.Label>
		<DataList.Value>
			<Link>
				{contract?.type || '-'}
			</Link>
		</DataList.Value>
	</DataList.Item>
    <DataList.Item>
		<DataList.Label minWidth="88px">Описание</DataList.Label>
		<DataList.Value>
		 
				{contract?.description || '-'}
		</DataList.Value>
	</DataList.Item>
      <DataList.Item>
		<DataList.Label minWidth="88px">Сообщение админа</DataList.Label>
		<DataList.Value>
				{contract?.message_admin || '-'}
		</DataList.Value>
	</DataList.Item>
</DataList.Root>
                <hr />
                </Container>
                <Container className="uploaded-document-files mb-5">
                    <Container>
                        <Heading size={'3'}>
                            Приложенные файлы
                        </Heading>
                    </Container>
                    <Container>
                    {contract.document.filter(file => file.url.split('.').pop() === 'pdf').map(pdf => {
                    let nameFile = pdf.url.split('/')
                    let nameFileStr = nameFile[nameFile.length - 1]
                    const content = renderContentPdfModal(pdf.url)
                    return (
                        <Flex align={'center'} gap={'2'} className="mt-2" direction={'column'} justify={'center'}>
                        <Text>📑{nameFileStr}</Text>
                        {/* <BaseModal 
                        maxWidth="700px"
                        showButton={<Button>Смотреть</Button>}
                        title={nameFileStr}
                        description={content}
                        cancelButton={<></>}
                        successButton={<Button>Готово</Button>}
                        /> */}
                        <a download={nameFileStr} href={pdf.url}>Скачать</a>
                        </Flex>
                    )
                })}
                <Flex align={'center'} justify={'start'} wrap={'wrap'} gap={'3'} className="m-3"> 
                    {
                        contract.document.filter(file => file.url.split('.').pop() !== 'pdf').map(pdf => {
                            let nameFile = pdf.url.split('/')
                            let nameFileStr = nameFile[nameFile.length - 1]
                            return (
                                <Flex direction={'column'} align={'center'} gap={'2'} className="mt-2" justify={'center'}>
                                <BaseModal 
                                maxWidth="800px"
                                maxHeight={`${window.screen.height - 200}px`}
                                showButton={<img src={pdf.url} width={'300px'} height={'300px'} />}
                                title=""
                                description={<img src={pdf.url} width={'100%'} height={'100%'} />}
                                cancelButton={<></>}
                                successButton={<Button>OK</Button>}
                                />
                                <a download={nameFileStr} href={pdf.url}>Скачать</a>
                                </Flex>
                            )
                        })
                    }
                    </Flex>
                 
                    </Container>
                   
                </Container>


                
                <Container className="uploaded-document-actions">
                
                    <Container> 
                    <Heading size={'3'}>
                        Действия
                    </Heading>
                    
                    </Container>
                    

    {  user.user.role === 'admin' ?     
    <>     
    <Container className="mb-5">
<RadioGroup.Root defaultValue="В обработке" name="example" value={status} onValueChange={e => setStatus(e)}>
	<RadioGroup.Item value="В обработке">В обработке</RadioGroup.Item>
	<RadioGroup.Item value="Пройдено">Пройдено</RadioGroup.Item>
	<RadioGroup.Item value="Отклонено">Отклонено</RadioGroup.Item>
</RadioGroup.Root>
                    </Container>

                    <Container className="mb-5">
                        <Heading size={'3'}>
                            Сообщение пользователю
                        </Heading>
                        <TextArea placeholder="Фото слишком мыльные..." rows={7} value={message} onChange={e => setMessage(e.target.value)}>

                        </TextArea>
                    </Container>
                    </>
                    :
                    <></>
}
                </Container>
              {user.user.role === 'admin' ?
                <Flex gap={'5'}>
                     
                    <Button color="grass" loading={isLoadingFetchSetStatusContract || isLoading} onClick={async () => await fetchSetStatusContract()}>
                        Сохранить
                    </Button>

                     <Button color="red" loading={isLoading || isLoadingFetchDeleteContract} onClick={async () => await fetchDeleteContract()}>
                        Удалить
                    </Button>
                </Flex>
                    :
                    <></>
}
            </Container>
                :
                <Container className="shadow-lg p-5 rounded-lg bg-zinc-50">
                    Договор не найден!
                </Container>
        }

        </Container>

    )
}